import logo from "./logo.svg";
import "./App.css";
import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import "bootstrap/dist/css/bootstrap.min.css";

import Login from "./components/pages/Login";
import Signup from "./components/pages/Signup";
import Dashboard from "./components/pages/Dashboard";
import ResetPassword from "./components/pages/ResetPassword";

import Home from "./components/pages/Home";

import Payment from "./components/pages/Payment";
import Doc from "./components/pages/Doc";

import TradeCopier from "./components/pages/TradeCopier";
import AccessDenied from "./components/pages/AccessDenied";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ProtectedRoutes from "./components/routes/ProtectedRoutes";
import { useAuth } from "./context/auth";
import { useEffect } from "react";

import AlgoPilot from "./components/pages/AlgoPilot";

import Success from "./components/pages/Success";
import DrawFlowEditor from "./components/pages/DrawFlowEditor";
import { ThemeProvider } from './context/ThemeContext';

function App() {
  return (
    <ThemeProvider>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/success" element={<Success />} />
        <Route path="/resetpassword" element={<ResetPassword />} />
        <Route path="/accessdenied" element={<AccessDenied />} />
        <Route path="/str" element={<DrawFlowEditor />} />

        {/* Protected Dashboard Routes - ProtectedRoutes sirf ek baar */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoutes>
              <Dashboard />
            </ProtectedRoutes>
          }
        >
          {/* ✅ Removed duplicate ProtectedRoutes from children */}
          <Route index element={<Navigate to="home" replace />} />
          <Route path="home" element={<Home />} />
          <Route path="tradecopier" element={<TradeCopier />} />
          <Route path="algopilot" element={<AlgoPilot />} />
          <Route path="payment" element={<Payment />} />
          <Route path="doc" element={<Doc />} />
        </Route>

        {/* Catch all route - redirect to login */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        style={{
          fontSize: "14px",
          marginTop: "20px",
          marginRight: "10px",
        }}
      />
    </ThemeProvider>
  );
}

export default App;